// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel {
    static getAttributeTypeMap() {
        return EnterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel.attributeTypeMap;
    }
}
EnterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel.discriminator = undefined;
EnterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel.additionalProperties = false;
EnterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel.attributeTypeMap = [
    {
        "name": "accountRelationshipIsPrimary",
        "baseName": "accountRelationshipIsPrimary",
        "type": "boolean"
    },
    {
        "name": "prescriberId",
        "baseName": "prescriberId",
        "type": "number"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "middleName",
        "baseName": "middleName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "suffix",
        "baseName": "suffix",
        "type": "string"
    },
    {
        "name": "nickname",
        "baseName": "nickname",
        "type": "string"
    },
    {
        "name": "npi",
        "baseName": "npi",
        "type": "string"
    },
    {
        "name": "taxId",
        "baseName": "taxId",
        "type": "string"
    },
    {
        "name": "prescriberLicenses",
        "baseName": "prescriberLicenses",
        "type": "Array<EnterpriseCoordinatorPrescriberServiceModelsPrescriberLicenseUpsearchModel>"
    },
    {
        "name": "externalIds",
        "baseName": "externalIds",
        "type": "Array<EnterpriseCoordinatorSharedExternalIdUpsearchModel>"
    },
    {
        "name": "addresses",
        "baseName": "addresses",
        "type": "Array<EnterpriseCoordinatorSharedAddressUpsearchModel>"
    },
    {
        "name": "phoneNumbers",
        "baseName": "phoneNumbers",
        "type": "Array<EnterpriseCoordinatorSharedPhoneUpsearchModel>"
    },
    {
        "name": "emailAddresses",
        "baseName": "emailAddresses",
        "type": "Array<EnterpriseCoordinatorSharedEmailAddressUpsearchModel>"
    },
];
//# sourceMappingURL=enterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel.js.map